import { ColumnDef } from '@tanstack/react-table'
import { Clinic } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { useState } from 'react'
import { ClinicPatientFlowDialog } from './ClinicPatientFlowDialog'

export const columns: ColumnDef<Clinic>[] = [
  {
    accessorKey: 'clinic_name',
    header: '診所名稱',
    cell: ({ row }) => {
      const clinicName = row.getValue('clinic_name') as string
      const alias = row.original.alias

      const displayName = clinicName || '未設定診所名稱'
      const aliasText = alias ? ` (${alias})` : ''

      return <span>{displayName}{aliasText}</span>
    },
  },
  {
    accessorKey: 'area',
    header: '區域',
  },
  {
    accessorKey: 'tags',
    header: '標籤',
    cell: ({ row }) => {
      const tags = (row.original.tags ?? []) as string[]
      if (tags.length === 0) return <span className="text-muted-foreground">-</span>
      return (
        <div className="flex flex-wrap gap-1">
          {tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="text-xs">
              {tag}
            </Badge>
          ))}
        </div>
      )
    },
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const isActive = row.getValue('is_active')
      return (
        <Badge variant={isActive ? 'default' : 'secondary'}>{isActive ? '啟用中' : '停用'}</Badge>
      )
    },
  },
  {
    accessorKey: 'broadcast_devices',
    header: '廣播裝置',
    cell: ({ row }) => {
      const devices = row.original.broadcast_devices || []
      return (
        <div className="flex items-center">
          <Badge variant="outline" className="mr-2">
            {devices.length}
          </Badge>
        </div>
      )
    },
  },
  {
    id: 'actions',
    header: '操作',
    cell: function ActionsCell({ row }) {
      const clinic = row.original
      const [patientFlowOpen, setPatientFlowOpen] = useState(false)

      return (
        <div className="flex items-center justify-end gap-2">
          {/* <Button variant="outline" size="sm" onClick={() => setPatientFlowOpen(true)}>
            <Info className="h-4 w-4 mr-1" />
            人流統計
          </Button> */}

          {/* 人流統計 Dialog - Only render when open */}
          {patientFlowOpen && (
            <ClinicPatientFlowDialog
              open={patientFlowOpen}
              onOpenChange={setPatientFlowOpen}
              clinicId={clinic.clinic_id}
            />
          )}
        </div>
      )
    },
  },
]
